import { render } from "./template_12.vue?vue&type=template&id=28c73eeb&scoped=true"
import script from "./template_12.vue?vue&type=script&lang=js"
export * from "./template_12.vue?vue&type=script&lang=js"

import "./template_12.vue?vue&type=style&index=0&id=28c73eeb&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c73eeb"]])

export default __exports__